  // Switch language

  var enBtn = document.getElementById('en-btn');
  var huBtn = document.getElementById('hu-btn');

  // Function to set the active language and class
  function setActiveLanguage(language) {
      if (language === 'en') {
          document.body.classList.remove('hu-lang');
          document.body.classList.add('en-lang');
          enBtn.classList.add('active');
          huBtn.classList.remove('active');
      } else if (language === 'hu') {
          document.body.classList.remove('en-lang');
          document.body.classList.add('hu-lang');
          huBtn.classList.add('active');
          enBtn.classList.remove('active');
      }
  }

  // Function to handle button clicks
  function handleButtonClick(event) {
      var language = event.target.id.split('-')[0]; // Extract language from button ID
      setActiveLanguage(language);
      localStorage.setItem('activeLanguage', language); // Store active language in localStorage
  }

  // Add event listeners to buttons
  enBtn.addEventListener('click', handleButtonClick);
  huBtn.addEventListener('click', handleButtonClick);

  // Check if active language is stored in localStorage and set it if present
  // Rava: Hungarian is the default. A visitor's own choice still wins.
  var storedLanguage = localStorage.getItem('activeLanguage');
  setActiveLanguage(storedLanguage || 'hu');

  // --- Rava: language from the URL -------------------------------------
  // ?lang=hu or ?lang=en forces the language on arrival and remembers it,
  // so a link can land someone straight in Hungarian. Runs after the
  // localStorage check above so the link always wins.
  try {
    var ravaParam = (location.search.match(/[?&]lang=(hu|en)/i) || [])[1];
    if (ravaParam) {
      ravaParam = ravaParam.toLowerCase();
      setActiveLanguage(ravaParam);
      localStorage.setItem('activeLanguage', ravaParam);
    }
  } catch (e) {}

  // --- Swym wishlist gomb felirat javítás (EN: Add to Wishlist) ---
(function () {
  var HU = 'Hozzáadás a kedvencekhez';
  var EN = 'Add to Wishlist';

  function isEnglish() {
    return document.body.classList.contains('en-lang') ||
           document.documentElement.lang.indexOf('en') === 0;
  }

  function fixAll() {
    var source = isEnglish() ? HU : EN;
    var target = isEnglish() ? EN : HU;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.indexOf(source) !== -1) {
        node.textContent = node.textContent.replace(source, target);
      }
    }
  }

  function start() {
    fixAll();
    // A Swym késve tölti be a gombot, ezért figyeljük a DOM változásait
    new MutationObserver(fixAll).observe(document.body, { childList: true, subtree: true });
    // Nyelvváltó gombokra is fusson le
    ['en-btn', 'hu-btn'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', function () { setTimeout(fixAll, 0); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();